<template>
  <v-footer padless>
    <v-card dark flat tile width="100%">
      <v-col cols="12" class="text-center">
        <v-btn plain text disabled> © 2021 - Telemonial </v-btn>
      </v-col>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: "global-footer",
};
</script>
